import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
var SelectHardwareIspxForm = observer(function (props) {
    var appStore = props.appStore, hardwareStore = props.hardwareStore, checkAddressStore = props.checkAddressStore, values = props.values, setFieldValue = props.setFieldValue;
    var hardwareCode = values.hardwareCode, hardwareMeshCode = values.hardwareMeshCode;
    var _a = props.planStore.planDetails.formValues, contractCode = _a.contractCode, includeVoipBundle = _a.includeVoipBundle;
    React.useEffect(function () {
        props.saleStore.setVoucher(null);
    }, []);
    React.useEffect(function () {
        props.summaryStore.getSummary(props.summaryStore.contractCode, values, props.checkAddressStore.nbnLocId, props.summaryStore.voipCode, null);
    }, [hardwareCode, hardwareMeshCode]);
    return (React.createElement(Form, null,
        React.createElement("section", { className: "container select-hardware" },
            React.createElement("div", { className: "row" },
                hardwareStore
                    .eligibleModems(contractCode, includeVoipBundle)
                    .map(function (hardware) { return (React.createElement("label", { htmlFor: hardware.code.toString(), className: "checkbox col-lg-12 grid-pod", key: hardware.code },
                    React.createElement("h3", { className: "pod-title" },
                        hardware.name,
                        ' ',
                        React.createElement("span", { className: "price" },
                            "$",
                            (hardware.currentPricing['sellInc'] / 100).toFixed(2))),
                    React.createElement(Field, { type: "radio", name: "hardwareCode", id: hardware.code, key: hardware.code, value: hardware.code, checked: values.hardwareCode === hardware.code, onClick: function () {
                            setFieldValue('hardwareCode', hardware.code);
                        } }),
                    React.createElement("div", { className: "label pod-image" },
                        React.createElement("img", { src: "/img/hardware/" + hardware.code + ".png", alt: hardware.code, width: "150" })),
                    React.createElement("p", { className: "pod-description" }, hardware.description))); }),
                React.createElement("label", { htmlFor: "hardwareCode", className: "checkbox col-sm-12 grid-pod" },
                    React.createElement(Field, { type: "radio", name: "hardwareCode", id: "hardwareCode", value: "", checked: values.hardwareCode === '', onClick: function () {
                            setFieldValue('hardwareCode', '');
                        } }),
                    React.createElement("h3", { className: "label pod-title" },
                        "I already have a",
                        ' ',
                        checkAddressStore.providerCode === 'Uniti' ? 'Fibre' : 'nbn™',
                        ' ',
                        "compatible modem"),
                    React.createElement("p", { className: "pod-description" },
                        "Please refer to your modem manufacturer and ensure your modem is compatible with the",
                        ' ',
                        checkAddressStore.providerCode === 'Uniti' ? 'Fibre' : 'nbn™',
                        ' ',
                        "technology available at your premises")),
                React.createElement("div", { className: "ml-5" },
                    React.createElement("div", { className: "alert alert-info", role: "alert" },
                        React.createElement("p", null, "When switching providers, you may also be required to update your connection settings when switching from another provider."),
                        React.createElement("p", null,
                            "If you switch from another provider and using a BYO modem, we may be limited in performing our standard testing to check if your",
                            ' ',
                            React.createElement("strong", null, checkAddressStore.providerCode === 'Uniti'
                                ? 'fibre'
                                : 'nbn™'),
                            ' ',
                            "service is working properly.",
                            ' '))))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: appStore.previousStep }, "Back"),
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
export var SelectHardwareIspx = inject('hardwareStore', 'checkAddressStore', 'appStore', 'planStore', 'summaryStore', 'saleStore', 'config')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.hardwareStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var hardwareStore = _a.hardwareStore;
        return hardwareStore.hardwareDetails.formValues
            ? hardwareStore.hardwareDetails.formValues
            : hardwareStore.hardwareDetails.formInitialValues;
    },
})(SelectHardwareIspxForm));
//# sourceMappingURL=SelectHardwareIspx.js.map